// @core/api/endpoints/team/get_team_ownership_transfer.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTeamOwnershipTransferResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Get ownership transfer details
 * Retrieves the details of a specific ownership transfer including status and involved parties.
 */
export async function GetTeamOwnershipTransfer(
  transfer_id: string,
  options?: RequestOptions
): Promise<GetTeamOwnershipTransferResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/ownership-transfers/:transfer_id`;
  requestPath = requestPath.replace(':transfer_id', encodeURIComponent(transfer_id));
  const requestOptions = options;
  return client.get<GetTeamOwnershipTransferResponse>(requestPath, { ...requestOptions });
}
